import { Modal } from "@arco-design/web-react";

import { GuestRoleChoicePanel } from "../../pages/GuestIntake/GuestRoleChoicePanel";

import "./GuestRoleConversionModal.css";

type GuestRoleConversionModalProps = {
  visible: boolean;
  expired?: boolean;
  onClose: () => void;
  onSelectRole?: (role: "mentor" | "mentee") => void;
};

export function GuestRoleConversionModal({
  visible,
  expired = false,
  onClose,
  onSelectRole,
}: GuestRoleConversionModalProps) {
  const handleSelectRole = (role: "mentor" | "mentee") => {
    onSelectRole?.(role);
    onClose();
  };

  return (
    <Modal
      visible={visible}
      title={null}
      footer={null}
      onCancel={onClose}
      closable
      className="guest-role-conversion-modal-dialog"
    >
      <GuestRoleChoicePanel
        expired={expired}
        onSelectRole={handleSelectRole}
        align="center"
      />
    </Modal>
  );
}
